import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import {MatToolbar, MatToolbarModule} from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';
import {MitarbeiterverwaltungPageComponent} from './components/mitarbeiterverwaltung-page/mitarbeiterverwaltung-page.component';
import {MitarbeiterTableComponent} from './components/mitarbeiter-table/mitarbeiter-table.component';
import {MitarbeiterService} from './mitarbeiter.service';
import {MitarbeiterEffects} from './store/effects/mitarbeiter.effects';
import {mitarbeiterverwaltungReducer} from './store/reducer/mitarbeiterverwaltung.reducer';
import {MitarbeiterFormdialogComponent} from './components/mitarbeiter-form-dialog/mitarbeiter-formdialog.component';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AnredeEffects} from './store/effects/anrede.effects';
import {AnredeService} from './anrede.service';
import {RolleEffects} from './store/effects/rolle.effects';
import {RolleService} from './rolle.service';
import {FirmaFormdialogComponent} from './components/firma-form-dialog/firma-formdialog.component';
import {BrancheService} from './branche.service';
import {BrancheEffects} from './store/effects/branche.effects';
import {FirmaService} from './firma.service';
import {FirmaEffects} from './store/effects/firma.effects';
import {MitarbeiterFilterComponent} from './components/mitarbeiter-filter/mitarbeiter-filter.component';
import {SharedModule} from '../../shared.module';
import {RollenverwaltungPageformComponent} from './components/rollenverwaltung-pageForm/rollenverwaltung-pageform.component';
import {RollenverwaltungTableComponent} from './components/rollenverwaltung-table/rollenverwaltung-table.component';
import {RollenverwaltungFormdialogComponent} from './components/rollenverwaltung-form-dialog/rollenverwaltung-formdialog.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {ZeiterfassungPageComponentModule} from '@src/app/pages/Zeiterfassung/zeiterfassung.module';
import {FirmaTableComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/firma-table/firma-table.component';
import {FirmaZeitFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/firmazeiten-form-dialog/firmazeiten-formdialog.component';
import {FeiertageFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/feiertage-form-dialog/feiertage-formdialog.component';
import {FeiertageTableComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/feiertage-table/feiertage-table.component';
import {SaldoTableComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/saldo-table/saldo-table.component';
import {UserinfoFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/userinfo-form-dialog/userinfo-formdialog.component';


@NgModule({
    imports: [
        StoreModule.forFeature('mitarbeiterverwaltung', mitarbeiterverwaltungReducer),
        EffectsModule.forFeature([MitarbeiterEffects, AnredeEffects, RolleEffects, BrancheEffects, FirmaEffects]),
        MatTableModule,
        CommonModule,
        TranslateModule,
        MatToolbarModule,
        FlexLayoutModule,
        MatListModule,
        MatCardModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        MatSortModule,
        BsDatepickerModule,
        MatCheckboxModule,
        SharedModule,
        MatTooltipModule,
        TooltipModule,
        ZeiterfassungPageComponentModule,

    ],
    providers: [MitarbeiterService, AnredeService, RolleService, BrancheService, FirmaService],
    declarations: [
        MitarbeiterverwaltungPageComponent,
        MitarbeiterTableComponent,
        MitarbeiterFormdialogComponent,
        FirmaFormdialogComponent,
        MitarbeiterFilterComponent,
        RollenverwaltungPageformComponent,
        RollenverwaltungTableComponent,
        RollenverwaltungFormdialogComponent,
        FirmaTableComponent,
        FirmaZeitFormdialogComponent,
        FeiertageFormdialogComponent,
        FeiertageTableComponent,
        SaldoTableComponent,
      UserinfoFormdialogComponent
    ],
})
export class MitarbeiterverwaltungModule {}
